
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/reusableComponents/inputField',['Vue'],function(Vue){
        return {
            name:'InputField',
            template:template,
            props: {id: {required: true}, label: {required: true}, text: {required: true}}
        }
    })
})('<div class="control-group"> <label class="control-label" :for="id">{{label}}</label> <div class="controls"> <input type="text" :id="id" :placeholder="label" :value="text" @input="$emit(\'update:text\',$event.target.value)" required> </div> </div>');
